<template>
	<div>
		<router-view/>
	</div>
</template>
<script>
	export default {
		name: 'home',
		data () {
    		return {
    			
    		}
    	},
		created(){},
		methods:{},
	}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/pages/home.vue